<template>
    <rkm-overlay>
        <rkm-layout-body title="Reabertura de atendimento finalizado">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/reabertura-atendimento/List'

export default {
    components: { List },
}
</script>